// extracted by mini-css-extract-plugin
module.exports = {"ImageFrame":"ImageFrame_ImageFrame__2rh_w","noBackground":"ImageFrame_noBackground__hR2wB"};